(() => {
  // Lazy-play product grid videos: only load + play when in view
  document.addEventListener('DOMContentLoaded', () => {
    const vids = document.querySelectorAll('video.tile-video');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) {
      vids.forEach(v => { try { v.play().catch(() => {}); } catch (_) {} });
      return;
    }
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const v = entry.target;
        if (entry.isIntersecting) v.play().catch(() => {});
        else v.pause();
      });
    }, { threshold: 0.2, rootMargin: '100px 0px' });
    vids.forEach(v => io.observe(v));
  });

  // Souls — infinite-loop vertical card deck (originals are flanked by clones)
  document.addEventListener('DOMContentLoaded', function () {
    const deck = document.querySelector('[data-souls-deck]');
    if (!deck) return;
    const originals = Array.from(deck.children);
    const N = originals.length;
    if (N < 2) return;
    // Prepend clones (preserve order)
    for (let i = N - 1; i >= 0; i--) {
      const c = originals[i].cloneNode(true);
      c.setAttribute('data-clone', 'pre');
      deck.insertBefore(c, deck.firstChild);
    }
    // Append clones
    originals.forEach(card => {
      const c = card.cloneNode(true);
      c.setAttribute('data-clone', 'post');
      deck.appendChild(c);
    });
    function jumpToOriginals() {
      deck.scrollTop = N * deck.clientHeight;
    }
    jumpToOriginals();
    let resetting = false;
    function checkLoop() {
      if (resetting) return;
      const h = deck.clientHeight;
      if (!h) return;
      const idx = Math.round(deck.scrollTop / h);
      if (idx < N) {
        resetting = true;
        deck.scrollTo({ top: (idx + N) * h, behavior: 'instant' });
        requestAnimationFrame(() => { resetting = false; });
      } else if (idx >= 2 * N) {
        resetting = true;
        deck.scrollTo({ top: (idx - N) * h, behavior: 'instant' });
        requestAnimationFrame(() => { resetting = false; });
      }
    }
    if ('onscrollend' in window) {
      deck.addEventListener('scrollend', checkLoop);
    } else {
      let t;
      deck.addEventListener('scroll', () => {
        clearTimeout(t);
        t = setTimeout(checkLoop, 90);
      });
    }
    window.addEventListener('resize', jumpToOriginals);

    // Sync the static dock with the currently visible card
    const dockSlots = document.querySelector('[data-dock-slots]');
    if (dockSlots) {
      function updateDock() {
        const h = deck.clientHeight;
        if (!h) return;
        const idx = Math.round(deck.scrollTop / h);
        const card = deck.children[idx];
        if (!card) return;
        const tpl = card.querySelector('[data-card-dock]');
        if (!tpl) return;
        const fragment = tpl.content.cloneNode(true);
        // Pad with empty slots up to 5 if shorter
        const tmp = document.createElement('div');
        tmp.appendChild(fragment);
        const filledCount = tmp.querySelectorAll('.dock__slot').length;
        for (let i = filledCount; i < 5; i++) {
          const s = document.createElement('span');
          s.className = 'dock__slot dock__slot--empty';
          s.setAttribute('aria-hidden', 'true');
          tmp.appendChild(s);
        }
        dockSlots.innerHTML = tmp.innerHTML;
      }
      // Initial sync after layout settles
      requestAnimationFrame(updateDock);
      let dockTimer;
      deck.addEventListener('scroll', () => {
        clearTimeout(dockTimer);
        dockTimer = setTimeout(updateDock, 60);
      });
      if ('onscrollend' in window) deck.addEventListener('scrollend', updateDock);
    }
  });

  // SMS modal — liquid glass popup (SMS + email)
  document.addEventListener('DOMContentLoaded', function () {
    var smsOverlay = document.querySelector('[data-sms-overlay]');
    if (!smsOverlay) return;
    var isProductPage = document.querySelector('[data-product]');
    if (window.LOHO && window.LOHO.smsModalDelay && !isProductPage) {
      var smsShown;
      try { smsShown = sessionStorage.getItem('lk_sms_shown'); } catch(e) {}
      if (!smsShown) {
        setTimeout(function () {
          smsOverlay.classList.add('active');
          try { sessionStorage.setItem('lk_sms_shown', '1'); } catch(e) {}
        }, window.LOHO.smsModalDelay * 1000);
      }
    }
    document.querySelectorAll('[data-sms-close]').forEach(function (el) {
      el.addEventListener('click', function () { smsOverlay.classList.remove('active'); });
    });
    smsOverlay.addEventListener('click', function (e) {
      if (e.target === smsOverlay) smsOverlay.classList.remove('active');
    });
    var toggleBtns = document.querySelectorAll('[data-toggle-mode]');
    var inputSms = document.querySelector('[data-input-sms]');
    var inputEmail = document.querySelector('[data-input-email]');
    toggleBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        toggleBtns.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var mode = btn.getAttribute('data-toggle-mode');
        if (inputSms) inputSms.style.display = mode === 'sms' ? '' : 'none';
        if (inputEmail) inputEmail.style.display = mode === 'email' ? '' : 'none';
      });
    });
    function saveName(n){ try { localStorage.setItem('lk_name', n); } catch(e) {} }
    function showSuccess(){
      var f = document.querySelector('[data-sms-form]');
      var s = document.querySelector('[data-sms-success]');
      if (f) f.style.display = 'none';
      if (s) s.style.display = '';
      setTimeout(function () { smsOverlay.classList.remove('active'); }, 2500);
    }
    var smsSubmit = document.querySelector('[data-sms-submit]');
    var smsPhone = document.querySelector('[data-sms-phone]');
    if (smsSubmit && smsPhone) {
      smsSubmit.addEventListener('click', function () {
        var phone = smsPhone.value.trim();
        if (!phone) return;
        smsSubmit.disabled = true; smsSubmit.textContent = '...';
        var apiUrl = (window.LOHO && window.LOHO.smsApiUrl) || '';
        if (!apiUrl) { smsSubmit.disabled = false; smsSubmit.textContent = 'Join'; console.error('SMS API URL not configured'); return; }
        var __lkTagSource = function(payload) {
          try { fetch('https://app.lohokur.com/api/marketing', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(Object.assign({ action: 'tag-source', source: (window.LOHO && window.LOHO.signupSource) || 'lohokur' }, payload)) }); } catch(e) {}
        };
        fetch(apiUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ phoneNumber: phone }) })
          .then(function (r) { return r.json(); })
          .then(function(d){ __lkTagSource({ phoneNumber: phone }); showSuccess(d); })
          .catch(function () { smsSubmit.disabled = false; smsSubmit.textContent = 'Join'; });
      });
    }
    var emailSubmit = document.querySelector('[data-email-submit]');
    var emailInput = document.querySelector('[data-sms-email]');
    var smsNameInput = document.querySelector('[data-sms-name]');
    if (emailSubmit && emailInput) {
      emailSubmit.addEventListener('click', function () {
        var smsName = smsNameInput ? smsNameInput.value.trim() : '';
        if (!smsName && smsNameInput) { smsNameInput.style.borderColor = 'var(--color-accent)'; return; }
        var email = emailInput.value.trim();
        if (!email || email.indexOf('@') === -1) return;
        if (smsName) saveName(smsName);
        emailSubmit.disabled = true; emailSubmit.textContent = '...';
        var apiUrl = (window.LOHO && window.LOHO.smsApiUrl) || '';
        if (!apiUrl) { emailSubmit.disabled = false; emailSubmit.textContent = 'Join'; return; }
        var baseUrl = apiUrl.replace('/sms/subscribe', '/email/subscribe');
        fetch(baseUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: email }) })
          .then(function (r) { return r.json(); })
          .then(function () {
            try { fetch('https://app.lohokur.com/api/marketing', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ action: 'tag-source', email: email, source: (window.LOHO && window.LOHO.signupSource) || 'lohokur' }) }); } catch(e){}
            if (smsName) {
              fetch('https://app.lohokur.com/api/customer-lookup', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: email, first_name: smsName }) }).catch(function(){});
            }
            showSuccess();
          })
          .catch(function () { emailSubmit.disabled = false; emailSubmit.textContent = 'Join'; });
      });
    }
  });

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const money = (cents) => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100); }
    catch { return '$' + (cents / 100).toFixed(2); }
  };

  // Cart drawer
  const drawer = $('#cart-drawer');
  const body = $('[data-cart-body]');
  const openers = $$('[data-cart-open]');
  const closers = $$('[data-cart-close]');
  const countEls = () => $$('[data-cart-count]');

  async function fetchCart() {
    const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return r.json();
  }
  function renderCart(cart) {
    countEls().forEach(el => el.textContent = cart.item_count);
    if (!body) return;
    if (!cart.item_count) {
      body.innerHTML = '<p style="color:var(--mu)">EMPTY</p>';
      return;
    }
    const rows = cart.items.map(it => `
      <li class="lst__row crt__row">
        <a class="crt__name" href="${it.url}">${it.product_title.toUpperCase()}${it.variant_title ? ' — ' + it.variant_title.toUpperCase() : ''}</a>
        <span class="lst__price">${money(it.final_line_price)}</span>
      </li>`).join('');
    body.innerHTML = `
      <ol class="lst__items">${rows}</ol>
      <div class="crt__foot"><span>SUBTOTAL</span><span>${money(cart.total_price)}</span></div>
      <div class="crt__actions">
        <a href="/cart" style="flex:1;padding:1em;border:1px solid var(--fg);text-align:center">VIEW BAG</a>
        <button type="button" data-cart-clear style="flex:1;padding:1em;border:1px solid var(--fg);background:transparent;color:var(--fg);text-align:center;cursor:pointer;font:inherit;letter-spacing:.06em;text-transform:uppercase">CLEAR</button>
        <a href="/checkout" style="flex:1;padding:1em;border:1px solid var(--fg);background:var(--fg);color:var(--bg);text-align:center">CHECKOUT</a>
      </div>`;
  }
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-cart-clear]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    try {
      const r = await fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } });
      if (r.ok) {
        if (location.pathname.replace(/\/$/, '') === '/cart') {
          location.reload();
        } else {
          countEls().forEach(el => el.textContent = '0');
          renderCart(await fetchCart());
        }
      }
    } finally {
      btn.disabled = false;
    }
  });
  function openDrawer() { drawer?.removeAttribute('hidden'); drawer?.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { drawer?.setAttribute('hidden', ''); drawer?.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  openers.forEach(b => b.addEventListener('click', async () => { openDrawer(); renderCart(await fetchCart()); }));
  closers.forEach(b => b.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  // Material elements — render a periodic-table-style grid of atomic tiles
  // based on the product's material tags. Atomic data is public scientific fact.
  (function () {
    const root = document.querySelector('[data-elements]');
    if (!root) return;
    const materials = (root.dataset.materials || '').toLowerCase();
    const E = {
      H:  ['1',  'H',  'Hydrogen',   '1.008'],
      C:  ['6',  'C',  'Carbon',     '12.011'],
      N:  ['7',  'N',  'Nitrogen',   '14.007'],
      O:  ['8',  'O',  'Oxygen',     '15.999'],
      Na: ['11', 'Na', 'Sodium',     '22.990'],
      Mg: ['12', 'Mg', 'Magnesium',  '24.305'],
      Al: ['13', 'Al', 'Aluminium',  '26.982'],
      Si: ['14', 'Si', 'Silicon',    '28.086'],
      P:  ['15', 'P',  'Phosphorus', '30.974'],
      S:  ['16', 'S',  'Sulfur',     '32.065'],
      K:  ['19', 'K',  'Potassium',  '39.098'],
      Ca: ['20', 'Ca', 'Calcium',    '40.078'],
      Cr: ['24', 'Cr', 'Chromium',   '51.996'],
      Fe: ['26', 'Fe', 'Iron',       '55.845'],
      Cu: ['29', 'Cu', 'Copper',     '63.546'],
      Zn: ['30', 'Zn', 'Zinc',       '65.38'],
      Sn: ['50', 'Sn', 'Tin',        '118.71'],
    };
    const MAP = [
      [/cotton|denim|linen|hemp|jersey|poplin/, ['C','H','O']],
      [/wool|cashmere|alpaca|mohair/,           ['C','H','N','O','S']],
      [/silk/,                                  ['C','H','N','O']],
      [/leather/,                               ['C','N','Cr','H']],
      [/\bfur\b/,                               ['Ca','S','N','C']],
      [/poly(?:ester)?|nylon|acrylic/,          ['C','H','O','N']],
      [/elastic|spandex|lycra/,                 ['C','H','N','O']],
      [/rubber/,                                ['C','H','S']],
      [/zinc|brass/,                            ['Zn','Cu','Cr']],
      [/iron|steel|hardware/,                   ['Fe','Cr','C']],
      [/tin|pewter/,                            ['Sn','Cu']],
      [/aluminium|aluminum/,                    ['Al']],
      [/wax/,                                   ['C','H','Si']],
      [/dye|pigment|reactive/,                  ['N','Na']],
      [/enzyme/,                                ['K','C']],
      [/silica|silicate|sand/,                  ['Si','O']],
    ];
    const seen = new Set();
    const tiles = [];
    function push(sym) {
      if (seen.has(sym)) return;
      const e = E[sym]; if (!e) return;
      seen.add(sym);
      tiles.push('<div class="elem"><span class="elem__num">' + e[0] + '</span><span class="elem__sym">' + e[1] + '</span><span class="elem__name">' + e[2] + '</span><span class="elem__weight">' + e[3] + '</span></div>');
    }
    MAP.forEach(([rx, atoms]) => { if (rx.test(materials)) atoms.forEach(push); });
    if (!tiles.length) ['C','H','O','N'].forEach(push);
    root.innerHTML = tiles.join('');
  })();

  // Garment lifecycle — fetch personalised phase text and render into the timeline
  (function () {
    const root = document.querySelector('[data-lifecycle]');
    if (!root) return;
    const id = root.dataset.productId;
    const title = root.dataset.productTitle || '';
    const materials = root.dataset.materials || '';
    const slots = {
      birth: root.querySelector('[data-phase="birth"]'),
      prime: root.querySelector('[data-phase="prime"]'),
      afterlife: root.querySelector('[data-phase="afterlife"]'),
      reincarnation: root.querySelector('[data-phase="reincarnation"]'),
    };
    Object.values(slots).forEach(el => el && el.classList.add('is-loading'));

    function readName() {
      try { return localStorage.getItem('lk_name') || ''; } catch (_) { return ''; }
    }
    function applyName(text, name) {
      if (!name || !text) return text;
      const possess = name + '’s';
      return text.replace(/\b([Yy])(our?)\b/g, (_m, first, rest) => {
        const lower = first === 'y';
        if (rest === 'our') return lower ? possess.toLowerCase() : possess;
        return lower ? name.toLowerCase() : name;
      });
    }

    const url = 'https://app.lohokur.com/api/garment-lifecycle?product_id=' +
      encodeURIComponent(id) +
      '&title=' + encodeURIComponent(title) +
      '&materials=' + encodeURIComponent(materials);

    fetch(url)
      .then(r => r.ok ? r.json() : Promise.reject(r.status))
      .then(data => {
        const name = readName();
        Object.keys(slots).forEach(k => {
          const el = slots[k];
          if (!el) return;
          el.classList.remove('is-loading');
          const t = data && data[k];
          if (t) el.textContent = applyName(t, name);
          else el.textContent = '';
        });
      })
      .catch(() => {
        Object.values(slots).forEach(el => {
          if (!el) return;
          el.classList.remove('is-loading');
          el.textContent = '';
        });
      });
  })();

  // Size guide — parses the description's <table> into selectable rows that each bind to a variant
  (function () {
    const prdRoot = $('[data-product]');
    if (!prdRoot) return;
    // A product can now render two [data-prd-desc] nodes: the written description
    // and the hidden size-table source. Pick the one that actually holds a <table>.
    const descNodes = Array.from(prdRoot.querySelectorAll('[data-prd-desc]'));
    const descSrc = descNodes.find(n => n.querySelector('table')) || descNodes[0];
    const overlay = $('[data-size-overlay]', prdRoot);
    const bodyEl = $('[data-size-body]', prdRoot);
    if (!descSrc || !overlay || !bodyEl) return;

    let variants = [];
    let options = [];
    try { variants = JSON.parse($('[data-variants]', prdRoot)?.textContent || '[]'); } catch (_) {}
    try { options = JSON.parse($('[data-product-options]', prdRoot)?.textContent || '[]'); } catch (_) {}
    const sizeIdx = options.findIndex(o => /size/i.test(o));

    const tmp = document.createElement('div');
    tmp.innerHTML = descSrc.innerHTML;
    const table = tmp.querySelector('table');
    if (!table) return;
    const rows = Array.from(table.querySelectorAll('tr')).map(r =>
      Array.from(r.children).map(c => c.textContent.trim())
    ).filter(r => r.length);
    if (rows.length < 2) return;

    let header = rows[0];
    let data = rows.slice(1);

    // Detect dual-unit table: row 2 alternating "inch" / "cm". Build a per-unit dataset.
    let unitsAvailable = [];
    let dataByUnit = {};
    let activeUnit = null;
    {
      const second = rows[1] || [];
      const unitsLow = second.map(c => (c || '').trim().toLowerCase());
      const cmIdx = [];
      const inchIdx = [];
      unitsLow.forEach((u, i) => {
        if (u === 'cm') cmIdx.push(i);
        else if (u === 'inch' || u === 'in' || u === '"') inchIdx.push(i);
      });
      if (cmIdx.length >= 2 || inchIdx.length >= 2) {
        if (cmIdx.length >= 2) {
          unitsAvailable.push('CM');
          dataByUnit.CM = rows.slice(2).map(r => [r[0] || '', ...cmIdx.map(i => r[i] || '')]);
        }
        if (inchIdx.length >= 2) {
          unitsAvailable.push('INCH');
          dataByUnit.INCH = rows.slice(2).map(r => [r[0] || '', ...inchIdx.map(i => r[i] || '')]);
        }
        header = rows[0];
        activeUnit = unitsAvailable[0];
        data = dataByUnit[activeUnit];
      }
    }

    // Auto-detect axis: ensure sizes end up as rows (Y axis), regardless of how the
    // merchant typed the table in the product description.
    {
      const norm = s => (s || '').replace(/\s+/g, '').toLowerCase();
      const variantSizes = sizeIdx !== -1
        ? variants.map(v => norm(v[`option${sizeIdx + 1}`])).filter(Boolean)
        : [];
      const sizeRx = /^(xxs|xs|s|m|l|xl|xxl|xxxl|\dxl|\d{1,3})$/i;
      const score = (items) => {
        if (!items.length) return 0;
        const n = items.map(norm);
        if (variantSizes.length) return n.filter(x => variantSizes.includes(x)).length;
        return n.filter(x => sizeRx.test(x)).length;
      };
      const rowScore = score(data.map(r => r[0]));
      const colScore = score(header.slice(1));
      if (colScore > rowScore) {
        const newHeader = [header[0], ...data.map(r => r[0])];
        const newData = header.slice(1).map((sizeLabel, sIdx) =>
          [sizeLabel, ...data.map(r => r[sIdx + 1] || '')]
        );
        header = newHeader;
        data = newData;
        window.__sizeChartTransposed = true;
      } else {
        window.__sizeChartTransposed = false;
      }
    }

    function findVariantFor(label) {
      if (sizeIdx === -1) return null;
      const key = `option${sizeIdx + 1}`;
      const norm = label.replace(/\s+/g, '').toLowerCase();
      return variants.find(v => (v[key] || '').replace(/\s+/g, '').toLowerCase() === norm) || null;
    }

    const escape = s => s.replace(/[<>&]/g, c => ({'<':'&lt;','>':'&gt;','&':'&amp;'}[c]));
    // Round measurement cells to whole numbers so the chart reads clean (display only —
    // the master size table keeps its exact fractions). Non-numeric cells pass through.
    const fmtNum = s => { const t = (s || '').trim(); return /^-?\d+(\.\d+)?$/.test(t) ? String(Math.round(parseFloat(t))) : t; };
    let selectedVid = null;
    let rowBtns = [];
    let addBtn = null;

    function build() {
      const cols = header.length;
      const gridStyle = `grid-template-columns:1.2fr repeat(${cols - 1},1fr)`;

      const staticUnit = (descSrc.getAttribute('data-size-unit') || '').trim();
      // Single-unit note now lives in the chart header ("All measurements in inches"),
      // so only render the unit toggle here when a chart actually has multiple units.
      const unitsHTML = unitsAvailable.length > 1
        ? `<div class="size-chart__units">${unitsAvailable.map(u =>
            `<button type="button" class="size-chart__unit${u === activeUnit ? ' is-active' : ''}" data-unit="${u}">${u}</button>`
          ).join('')}</div>`
        : '';

      const headHTML = `<div class="size-chart__head-row" style="${gridStyle}">` +
        header.map(h => `<span class="size-chart__head-cell">${escape(h)}</span>`).join('') +
        `</div>`;

      const rowsHTML = data.map(r => {
        const v = findVariantFor(r[0]);
        const disabled = v ? !v.available : false;
        const vid = v ? v.id : '';
        const cls = `size-chart__row${disabled ? ' is-disabled' : ''}`;
        return `<button type="button" class="${cls}" data-variant-id="${vid}"${disabled ? ' disabled' : ''} style="${gridStyle}">` +
          r.map((c, ci) => `<span class="size-chart__cell${ci === 0 ? ' size-chart__cell--label' : ' size-chart__cell--value'}">${escape(ci === 0 ? c : fmtNum(c))}</span>`).join('') +
          `</button>`;
      }).join('');

      bodyEl.innerHTML =
        unitsHTML +
        `<div class="size-chart__grid">${headHTML}${rowsHTML}</div>` +
        `<button type="button" class="size-chart__add" data-size-add disabled>Select size</button>`;

      rowBtns = $$('.size-chart__row:not(:disabled)', bodyEl);
      addBtn = $('[data-size-add]', bodyEl);
      attachHandlers();
    }

    function selectRow(btn) {
      const vid = btn.dataset.variantId;
      const wasActive = btn.classList.contains('is-active');
      rowBtns.forEach(r => r.classList.remove('is-active'));
      if (wasActive) {
        selectedVid = null;
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Select size'; }
      } else {
        btn.classList.add('is-active');
        const idInput = $('[data-variant-id]', prdRoot);
        selectedVid = vid || (idInput ? idInput.value : null);
        if (vid && idInput) idInput.value = vid;
        if (addBtn) {
          addBtn.disabled = !selectedVid;
          addBtn.textContent = 'Select size';
        }
      }
    }

    function attachHandlers() {
      rowBtns.forEach(btn => btn.addEventListener('click', () => selectRow(btn)));
      addBtn?.addEventListener('click', () => {
        if (!selectedVid) return;
        // "Select size" applies the chosen size to the product (ticks the matching size
        // chip so stock/variant update) and closes — the main Add to Cart does the purchase.
        const v = variants.find(x => String(x.id) === String(selectedVid));
        if (v && sizeIdx !== -1) {
          const sizeVal = (v['option' + (sizeIdx + 1)] || '').replace(/\s+/g, '').toLowerCase();
          $$('[data-option-input]', prdRoot).forEach(inp => {
            if ((inp.value || '').replace(/\s+/g, '').toLowerCase() === sizeVal) {
              inp.checked = true;
              inp.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        }
        const idInput = $('[data-variant-id]', prdRoot);
        if (idInput) idInput.value = selectedVid;
        close();
      });
      $$('.size-chart__unit', bodyEl).forEach(btn => {
        btn.addEventListener('click', () => {
          if (btn.classList.contains('is-active')) return;
          activeUnit = btn.dataset.unit;
          // Re-derive data with the new unit, then re-run axis detect by reusing the saved transformation.
          let newData = dataByUnit[activeUnit];
          // If original axis-detect transposed, we need to re-transpose the new data the same way.
          if (window.__sizeChartTransposed) {
            const oldHeader = rows[0];
            newData = oldHeader.slice(1).map((sizeLabel, sIdx) =>
              [sizeLabel, ...newData.map(r => r[sIdx + 1] || '')]
            );
          }
          data = newData;
          selectedVid = null;
          build();
        });
      });
    }

    build();
    $$('[data-size-open]', prdRoot).forEach(el => { el.hidden = false; });

    function open() {
      overlay.removeAttribute('hidden');
      overlay.style.display = 'block';
      $$('[data-size-open]', prdRoot).forEach(el => { el.style.display = 'none'; });
      requestAnimationFrame(() => overlay.scrollIntoView({ behavior: 'smooth', block: 'center' }));
    }
    function close() {
      overlay.setAttribute('hidden', '');
      overlay.style.display = '';
      $$('[data-size-open]', prdRoot).forEach(el => { el.style.display = ''; });
    }
    $$('[data-size-open]', prdRoot).forEach(el => el.addEventListener('click', open));
    $$('[data-size-close]', overlay).forEach(b => b.addEventListener('click', close));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !overlay.hasAttribute('hidden')) close(); });
  })();

  // Product variant selection
  const root = $('[data-product]');
  if (root) {
    const variantsEl = $('[data-variants]', root);
    let variants = [];
    try { variants = JSON.parse(variantsEl?.textContent || '[]'); } catch {}
    const idInput = $('[data-variant-id]', root);
    const addBtn = $('[data-add]', root);
    const priceEl = $('.prd__price', root);

    function currentSelection() {
      const fieldsets = $$('[data-option-index]', root);
      return fieldsets.map(fs => $(`input:checked`, fs)?.value).filter(Boolean);
    }
    function findVariant(opts) {
      return variants.find(v => {
        const vOpts = [v.option1, v.option2, v.option3].filter(Boolean);
        return vOpts.length === opts.length && vOpts.every((o, i) => o === opts[i]);
      });
    }
    function update() {
      const v = findVariant(currentSelection());
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'ADD TO BAG' : 'SOLD OUT';
      }
      if (priceEl) priceEl.textContent = money(v.price);
    }
    $$('[data-option-input]', root).forEach(el => el.addEventListener('change', update));

    const form = $('form', root);
    form?.addEventListener('submit', async e => {
      if (!window.fetch) return;
      e.preventDefault();
      const fd = new FormData(form);
      const r = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
      if (r.ok) { openDrawer(); renderCart(await fetchCart()); }
      else { form.submit(); }
    });
  }
})();
